import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';

// Founder UX Sprint — Suite Unification. Presentation-only "What is this suite?"
// banner shared by client suites that lack a hero (Climara, TalentStart,
// TalentTrain, TalentFix, TalentCompetency). Copy lives in i18n suiteHero.*.
export const SuiteHero = ({ suite, icon: Icon, dataTestId }) => {
  const { t } = useTranslation();
  return (
    <Card className="p-4 flex items-start gap-3 shadow-card border-primary/20 bg-primary/5" data-testid={dataTestId || `suite-hero-${suite}`}>
      {Icon && <Icon className="h-5 w-5 text-primary mt-0.5 shrink-0" />}
      <div className="flex-1">
        <h3 className="font-semibold text-sm">{t(`suiteHero.${suite}.title`)}</h3>
        <p className="text-sm text-muted-foreground mt-1">{t(`suiteHero.${suite}.body`)}</p>
      </div>
    </Card>
  );
};

export default SuiteHero;
